import React, { useContext } from 'react'
import { motion, AnimatePresence, } from 'motion/react'
import classNames from 'classnames'
import CardContext from 'context/card'
import checker from 'images/checker.png'

export const imgSizes = {
    'lg': 257,
    'md': 203,
    'sm': 196,
    'xs': 146,
}

export default function Image(){
    const props = useContext(CardContext)
    
    const {
        alt,
        product,
        isHovered,
        imgBackground,
        imgLeftOrRight,
        objectFit,
        imgSize = 'md',
    } = props

    const className = imgLeftOrRight ? 'd-flex a-stretch' : ''
    
    const height = imgSizes[imgSize]
    const optimize = url => url ? `${url}${url.includes('?') ? '&' : '?'}height=${height*2}` : null
    
    const image = optimize(product ? product?.image : props?.image ? props.image : checker)
    const hoverImage = optimize(product ? product?.hoverImage : props?.hoverImage)
    
    if(imgBackground) return
    return(
        <div
            className={classNames(className, 'p-relative')}
            style={{ height }}
        >
            <AnimatePresence>
                <motion.img
                    key={(isHovered && hoverImage) ? hoverImage : image}
                    // Requesting the image with the height query param (times 2) optimizes data usage without loosing much (if any) quality
                    src={(isHovered && hoverImage) ? hoverImage : image}
                    alt={alt}
                    initial={{ opacity: 0 }}
                    exit={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: .5, ease: "easeInOut" }}
                    className='p-absolute top-0 left-0 w-100 h-100'
                    style={{ objectFit: (isHovered && hoverImage) ? 'cover' : objectFit ? objectFit : 'contain' }}
                    loading="lazy"
                />
            </AnimatePresence>
        </div>
    )
}
